import React, { FC } from 'react';
import classNames from 'classnames';

// eslint-disable-next-line max-len
const hbd = 'M-3.748-.088a6.973,6.973,0,0,1-.044-.745c0-.774.234-1.125,1.14-1.739a5.967,5.967,0,0,0,1.8-1.5A2.746,2.746,0,0,0-.343-5.8,2.513,2.513,0,0,0-1.381-7.846a4.567,4.567,0,0,0-2.937-.877A4.728,4.728,0,0,0-7.547-7.7,3.7,3.7,0,0,0-8.7-5.494l2.162.263a2.12,2.12,0,0,1,.351-1.11,2.047,2.047,0,0,1,1.753-.833c1.242,0,2.016.555,2.016,1.446,0,.672-.336,1.125-1.286,1.753a4.884,4.884,0,0,0-1.373,1.1,2.927,2.927,0,0,0-.6,1.9l.015.278a5.027,5.027,0,0,1-.044.614ZM-5.793,1.125v2h2.119v-2Z';

const HelpButton: FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({ ...args }) => (
    <button type="button" className="order-parts-img__help-button" {...args}>
        ヘルプ
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
        >
            <g
                id="グループ_3621"
                data-name="グループ 3621"
                transform="translate(16 4)"
            >
                <rect
                    id="長方形_2811"
                    data-name="長方形 2811"
                    width="20"
                    height="20"
                    rx="10"
                    transform="translate(-16 -4)"
                    fill="#fff"
                />
                <path
                    id="パス_1037"
                    data-name="パス 1037"
                    d={hbd}
                    transform="translate(-1.589 8.785)"
                    fill="#484848"
                />
            </g>
        </svg>
    </button>
);

interface IOrderPartsImgProps {
    className?: string;
    partsName: string;
    showHelpBtn?: boolean;
    onHelpClick: (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => void;
}

export const OrderPartsImg: FC<IOrderPartsImgProps> = ({
    className,
    partsName,
    showHelpBtn = false,
    onHelpClick,
}) => (
    <div className={classNames('order-parts-img', className)}>
        <div className="left" />
        <div className="center">
            <p className="page-title">{partsName}</p>
        </div>
        <div className="right">
            {showHelpBtn && <HelpButton onClick={onHelpClick} />}
        </div>
    </div>
);
